import { formatPhone } from '#app/utils/help-contact.ts'

/** A real person to call: the organiser's contact, big tap targets. */
export function HelpCard({
	name,
	phone,
	email,
}: {
	name: string
	phone: string | null
	email: string | null
}) {
	return (
		<section
			id="hjelp"
			className="hk-section hk-help"
			aria-labelledby="help-title"
		>
			<div className="hk-container">
				<div className="hk-help-card">
					<div className="hk-help-window" aria-hidden="true">
						<span />
						<span />
						<span />
						<span />
					</div>
					<div className="hk-help-text">
						<p className="hk-kicker hk-kicker-light">Hjelp</p>
						<h2 id="help-title" className="hk-h2">
							Treng du hjelp?
						</h2>
						<p className="hk-help-lede">
							Kontakt {name} for hjelp med reservasjon av billettar — på telefon
							eller e-post.
						</p>
					</div>
					<div className="hk-help-actions">
						{phone ? (
							<a
								className="hk-btn"
								href={`tel:${phone.replace(/\s/g, '')}`}
								aria-label={`Ring ${name} på ${formatPhone(phone)}`}
							>
								<svg
									viewBox="0 0 24 24"
									width="20"
									height="20"
									aria-hidden="true"
								>
									<path
										fill="currentColor"
										d="M19.23 15.26l-2.54-.29a1.99 1.99 0 0 0-1.64.57l-1.84 1.84a15.05 15.05 0 0 1-6.59-6.59l1.85-1.85c.43-.43.64-1.03.57-1.64l-.29-2.52a2 2 0 0 0-1.99-1.77H5.03c-1.13 0-2.07.94-2 2.07.53 8.54 7.36 15.36 15.89 15.89 1.13.07 2.07-.87 2.07-2v-1.73c.01-1.01-.75-1.86-1.76-1.98z"
									/>
								</svg>
								{formatPhone(phone)}
							</a>
						) : null}
						{email ? (
							<a
								className="hk-btn hk-btn-ghost"
								href={`mailto:${email}?subject=Hjelp%20Huskonsertfestivalen`}
							>
								<svg
									viewBox="0 0 24 24"
									width="20"
									height="20"
									aria-hidden="true"
								>
									<path
										fill="none"
										stroke="currentColor"
										strokeWidth="2"
										strokeLinecap="round"
										strokeLinejoin="round"
										d="M3 8l7.89 5.26a2 2 0 0 0 2.22 0L21 8M5 19h14a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2z"
									/>
								</svg>
								{email}
							</a>
						) : null}
					</div>
				</div>
			</div>
		</section>
	)
}
